import { CADConnectionType } from '@shared/enums';
import { Tier } from '../../enums/tier.enum';

export class CurrentSiteAuthDataModel {
  public Tier: Tier;
  public MaxUploadSize: number;
  public Name: string;
  public Guid: string;
  public MaxStorageSize: string;
  public LogoSrc: string;
  public TimeZoneId: string;
  public MentoringEnabled: boolean;
  public PowerDmsEnabled: boolean;
  public TrainingCoursesEnabled: boolean;
  public CadImportEnabled: boolean;
  public FoundationUserManagementEnabled: boolean;
  public PowerSuitEidAuthEnabled: boolean;
  public SecureSignInEnabled: boolean;
  public SyncPlatformExtendedUserFieldsEnabled: boolean;
  public PlatformTasksEnabled: boolean;
  public GlobalSiteId: string;
  public RaceAndSexReportingEnabled: boolean;
  public UserwayEnabled: boolean;
  public PlatformTopNavEnabled: boolean;
  public CADConnectionType: CADConnectionType;
  public AllowAiWritingAssistant: boolean;
  public PipEnabled: boolean;
  public RatingScaleUpdateEnabled: boolean;
  public AssignPolicyDocumentsEnabled: boolean;
  public AITraineeSummaryEnabled: boolean;
  PowerEngageIntegrationEnabled: boolean;
}
